<template>
  <div>
    <el-header class="icon-header">
      <SiteName />
      <div class="menu-bar">
        <Menu :menuData="menuData" :index="activeIndex" @select="toRouter"></Menu>
      </div>
      <div class="msg-dropdown">
        <el-popover
          v-model="showTip"
          placement="bottom-end"
          title=""
          trigger="manual"
          width="90"
          popper-class="msg-tip"
          content="有新的未读消息"
        >
          <span slot="reference" style="position:absolute;left:10px;top:36px"></span>
        </el-popover>
        <el-dropdown placement="bottom-end" @command="handleCommand" @visible-change="handleVisible">
          <div>
            <span class="msg-icon el-icon-message-solid"></span>
            <span v-if="unreadMessageNum > 0" class="msg-star">{{ unreadMessageNum > 999 ? '999+' : unreadMessageNum }}</span>
          </div>
          <el-dropdown-menu
            slot="dropdown"
            v-infinite-scroll="loadMessage"
            :infinite-scroll-immediate="false"
            :infinite-scroll-distance="10"
          >
            <div class="msg-drop-title">
              <span>未读消息</span>
              <el-button type="text" @click="routeToMessage">消息中心>></el-button>
            </div>
            <div v-if="messageList.length === 0" class="msg-empty">暂无新消息</div>
            <el-dropdown-item
              v-for="(msg, index) in messageList"
              :key="index"
              :divided="true"
              :style="{ color: msg.readStatus === 1 ? '#aaa' : '#666' }"
              :command="msg.subOrderLogId"
            >
              <div class="msg-item">
                <div class="msg-preffix">{{ msg.subOrder }}</div>
                <div class="msg-title">{{ msg.statusChangeDesc }}</div>
                <div class="msg-time">{{ msg.createTime }}</div>
              </div>
            </el-dropdown-item>
            <div v-if="messageLoading" style="text-align:center;font-size:12px;color:#ff8b00">
              <span class="el-icon-loading"></span>加载中
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="user-info">
        <div class="user-info-box">
          <span>
            <i class="el-icon-cc-user"></i>
            {{ userName }}&nbsp;
          </span>
          <span style="cursor: pointer" @click="handleAccountCommand('logout')">退出</span>
        </div>
      </div>
    </el-header>
    <el-container>
      <div class="main__wrap">
        <el-main class="main-content" id="mainscroll">
          <router-view ref="routeView" v-if="!isKeepAlive" />
        </el-main>
      </div>
    </el-container>
    <MessageDrawer :show-drawer="showDrawer" :message-model="messageModel" @close="showDrawer = false" />
  </div>
</template>

<script>
import SiteName from '@/components/SiteName'
import Menu from '@/components/common/Meun'
import MessageDrawer from '@/views/message/MessageDrawer.vue'

import { mapGetters } from 'vuex'

export default {
  components: {
    SiteName,
    Menu,
    MessageDrawer
  },
  props: ['menu'],
  data() {
    return {
      breadcrumb: [],
      isCollapseMenu: false,
      isShowTagNav: true,
      routerMap: {
        home: 'dashboard',
        putAd: 'projectOrder',
        data: 'orderBasicData',
        finance: 'financialIndex',
        account: 'loginAccountInfo',
        videoProduce: 'mediaIndex',
        materialPackage: 'materialPackage',
        regionEditor: 'regionEditor',
        directPackage: 'directPackage'
      },
      messageList: [],
      pageNo: 1,
      messageLoading: false,
      showDrawer: false,
      messageModel: {},
      showTip: false
    }
  },
  computed: {
    ...mapGetters(['unreadMessageNum', 'showMessageTip']),
    isKeepAlive() {
      return false
    },
    // eslint-disable-next-line vue/return-in-computed-property
    userName() {
      const user = this.$service.state.user || {}
      return user.userName
    },
    menuData() {
      const menu = (this.$appState.$get('authMenus') || []).filter(
        (item) => item.children
      )
      const index = menu.findIndex((item) => item.elId === 'workbag')
      // 特殊处理工具包的children
      if (index >= 0 && menu[index].children && menu[index].children.length > 0) {
        menu[index].children.sort((prev, next) => {
          return prev.seq - next.seq
        })
        return menu
      } else {
        return menu.filter((item) => item.elId !== 'workbag')
      }
    },
    activeIndex() {
      const parentPath = this.$route.meta.parentPath
      const activeIndexMap = {
        dashboard: 'home',
        advertisement: 'putAd',
        dataReport: 'data',
        financialManagement: 'finance',
        accountManagement: 'account',
        workbag: 'workbag'
      }
      return activeIndexMap[parentPath]
    }
  },
  watch: {
    showMessageTip(val) {
      this.showTip = val
    }
  },
  methods: {
    toRouter(index) {
      const name = this.routerMap[index]
      if (index === 'customCrowd' && this.$store.state.dmpUrl) {
        window.open(this.$store.state.dmpUrl)
      }
      if (name === 'projectOrder') {
        this.handleRouteAdvertise()
      } else {
        this.$router.push({ name }).catch(() => {})
      }
    },
    handleAccountCommand(command) {
      if (command === 'logout') {
        this.$service.logout().then(() => {
          this.$router.push({ name: 'login' })
          this.$appState.$remove('authMenus')
          this.$appState.$remove('permissions')
        })
      } else {
        this.toRouter(command)
      }
    },
    handleRouteAdvertise() {
      const currentRoute = this.$route.name
      if (currentRoute === 'projectOrder') {
        const view = this.$refs.routeView
        const projectOrder = view.$children[0] || {}
        projectOrder.isShowList = true
      } else {
        this.$router.push({ name: 'projectOrder' })
      }
    },
    loadMessage() {
      const messageLen = this.messageList.length
      if (this.messageLoading) return
      if (messageLen >= this.unreadMessageNum || (messageLen / 10 - 1 >= this.pageNo)) return
      const params = {
        pageNo: this.pageNo,
        pageSize: 10,
        readStatus: 0
      }
      this.messageLoading = true
      this.$service.getMessagePageList(params).then(res => {
        this.messageLoading = false
        this.messageList = this.messageList.concat(res.rows)
        this.pageNo++
      })
        .catch(() => {
          this.messageLoading = false
        })
    },
    handleVisible(visible) {
      if (visible) {
        this.pageNo = 1
        this.messageList = []
        this.loadMessage()
        this.$store.dispatch('setShowMessageTip', false)
      }
    },
    handleCommand(id) {
      const message = this.messageList.find(item => item.subOrderLogId === id)
      message.readStatus = 1
      this.messageModel = this.cloneDeep(message)
      this.showDrawer = true
      this.markAsRead([id])
    },
    markAsRead(ids) {
      const params = ids
      return this.$service.markMessageAsRead(params).then(res => {
        this.$store.dispatch('getUnreadMsgNum')
      })
    },
    routeToMessage() {
      if (this.$route.name !== 'message') {
        this.$router.push('/message.html')
      }
    }
  },
  created() {
    this.isCollapseMenu = !!this.$appState.$get('isCollapseMenu')
    this.$bus.$on('breadcrumb-change', (breadcrumb) => {
      this.breadcrumb = breadcrumb
    })
    this.$service.queryDictData({ type: 'dmp_url' }).then((res) => {
      if (res && res.length) {
        this.$store.commit('setDmpUrl', res[0].value)
      }
    })
    this.$store.dispatch('getUnreadMsgNum')
  },
  mounted() {
    this.$bus.$on('scroll-top', () => {
      document.getElementById('mainscroll').scrollTop = 0
    })
    this.showTip = this.showMessageTip
    if (this.showTip) {
      setTimeout(() => {
        this.$store.dispatch('setShowMessageTip', false)
      }, 5000)
    }
  },
  destroyed() {}
}
</script>

<style lang="stylus">
.msg-dropdown
  position relative
  margin-left auto
  margin-right 22px
  line-height 60px
  cursor pointer
  .msg-star
    position absolute
    top 12px
    left 12px
    padding 0 4px
    height 14px
    border-radius 14px
    background-color #f01122
    line-height 14px
    font-size 12px
    text-align center
.el-dropdown-menu
  width 650px
  max-height 200px
  overflow-y auto
  overflow-x hidden
  &::-webkit-scrollbar
    width 6px
  &::-webkit-scrollbar-track
    border-radius 6px
    background rgba(0, 0, 0, 0.1)
  &::-webkit-scrollbar-thumb
    border-radius 4px
    background rgba(0, 0, 0, 0.2)
.msg-item
  display flex
  flex-flow row nowrap
  width 100%
.msg-drop-title
  display flex
  flex-flow row nowrap
  justify-content space-between
  padding 0 28px 0 17px
  line-height 30px
  font-size 14px
  color #666
  .el-button
    padding 0
.msg-preffix
  padding-right 10px
  border-right 1px solid #eee
  width 120px
.msg-title
  padding 0 10px
  border-right 1px solid #eee
  width 290px
  min-width 290px
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
.msg-time
  width 160px
  padding-left 10px
.user-info-box
  color #fff
  font-size 14px
.el-dropdown
  color white
.menu-bar
  margin-left 36px
.el-menu-item
  padding 0px 28px
.menu-bar ul
  height 60px
  display flex
  align-items center
  margin 0
.menu-bar ul li
  height 60px
  line-height 60px
.el-menu--horizontal>.el-menu-item
  font-size 14px
  font-weight 400
  color rgba(255, 255, 255, 0.65)
  background none
.el-menu--horizontal>.el-menu-item.is-active
  font-size 14px
  font-weight 500
  color rgba(255, 255, 255, 1)
  background none
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover
  background #ff8b00
  color #fff
  font-weight 500
.main-content > .tab-page
  position relative
.aside-menu--wrapper
  border-right 1px solid #e4e4e4
.el-submenu__title
  font-weight bold
.el-submenu .el-menu-item
  border-bottom 0.0625rem solid #f2f2f2
.el-submenu .el-menu-item a
  color #666
.el-menu-item.is-active, .el-menu-item.is-active a, .el-menu-item.is-active:hover, .el-menu-item.is-active a:hover
  color #FF8B00
  background rgba(0, 0, 0, 0.05)
.el-dropdown
  height 100%
.el-menu-item, .el-submenu__title
  line-height 46px
  height 46px
.breadcrumb__wrap
  z-index 1000
  background #fff
  width 100%
  top 0
  left 0
  line-height 46px
  height 46px
  position relative
  box-shadow 0 0 20px 0 rgba(0, 0, 0, 0.12)
  padding-left 20px
  box-sizing border-box
  .el-breadcrumb
    line-height 46px
.main__wrap
  display block
  -webkit-box-flex 1
  -ms-flex 1
  flex 1
  -ms-flex-preferred-size auto
  flex-basis auto
  overflow auto
  height calc(100vh - 60px)
.msg-empty
  border-top 1px solid #f2f2f2
  width 100%
  height 60px
  line-height 60px
  font-size 12px
  color #999
  text-align center
.msg-tip
  padding 10px
  border none
  min-width 90px
  font-size 12px
  background-color rgba(10, 10, 10, .5)
  color #fff
.msg-tip.el-popper[x-placement^=bottom] .popper__arrow
  border-bottom-color rgba(10, 10, 10, .2)
  &::after
    border-bottom-color rgba(10, 10, 10, .2)
</style>
